'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _CarbonUnderground = require('./CarbonUnderground200.css');

var _CarbonUnderground2 = _interopRequireDefault(_CarbonUnderground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarbonUnderground200 = (_dec = (0, _reactCssModules2.default)(_CarbonUnderground2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CarbonUnderground200, _Component);

  function CarbonUnderground200(props) {
    (0, _classCallCheck3.default)(this, CarbonUnderground200);
    return (0, _possibleConstructorReturn3.default)(this, (CarbonUnderground200.__proto__ || (0, _getPrototypeOf2.default)(CarbonUnderground200)).call(this, props));
  }

  (0, _createClass3.default)(CarbonUnderground200, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Carbon Underground 200';
      var description = "Get your money out of fossil fuels. Use Fossil Free Funds to find out if you're invested in the largest owners of carbon reserves.";
      var url = _config2.default.domain + _config2.default.routes.carbonunderground200;

      var bannerImage = 'smoke';
      var bannerHeadline = 'The Carbon Underground 200™';
      var bannerSubtitle = 'The top 200 coal and oil/gas reserve owners in the world';
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-' + bannerImage },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-headline' },
                bannerHeadline
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-subtitle' },
                bannerSubtitle
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Find out if you\'re invested in 200 of the largest owners of carbon reserves'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The Carbon Underground 200\u2122, compiled and maintained by FFI Solutions (formerly Fossil Free Indexes\u2120), identifies the top 100 coal and the top 100 oil and gas publicly-traded reserve holders globally, ranked by the potential carbon emissions content of their reported reserves.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Rankings are constructed using a reserves-based methodology with the underlying core data based on \u201Creported\u201D reserves. Coal reserves are the sum of proven and probable reserves based on the last reported reserves amount by mine. Reserves are allocated to listed companies based on percentage ownership of individual mines. Oil and gas companies are ranked on proven reserves (1P) net of royalty payments.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The Carbon Underground 200\u2122 relies on the IPCC Revised 1996 Guidelines for National Greenhouse Gas Inventories as a methodological framework. The calculation of CO2 emission potential requires several conversions to the raw reserves figure.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.fficu200,
                    xstrong: true,
                    title: 'Carbon Underground 200 - FFI Solutions'
                  },
                  'Visit FFI Solutions online to learn more about licensing the full list of 200 companies',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'x-ffi-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-ffi-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-ffi-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-ffi-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-ffi-photo',
                    title: 'FFI Solutions'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-ffi-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-ffi-info-title' },
                      'FFI Solutions'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'FFI Solutions (formerly Fossil Free Indexes\u2120) provides benchmarks, research and investment solutions that support carbon-responsible investing, with an initial focus on broad market indexes ex-fossil fuels that align with the divestment movement. Embracing the transition to a low carbon economy through responsible investing, they join the growing number of analysts who believe fossil fuel companies are overvalued and a risky long-term investment based on unburnable reserves. FFI Solutions indexes and rankings are licensed for funds, ETFs, and separate accounts, as the basis for investable products and strategies.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.ffi,
                          xstrong: true,
                          title: 'FFI Solutions'
                        },
                        'Learn more at www.ffisolutions.com',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-disclaimer-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-disclaimer-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-disclaimer-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-disclaimer-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-disclaimer-photo',
                    title: 'Disclaimer'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-disclaimer-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-disclaimer-info-title' },
                      'Disclaimer'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Mutual funds screened for Carbon Underground 200\u2122 companies by Fossil Free Funds would flag the equities of only the reserve-owning corporate entities of Carbon Underground 200\u2122 ranked companies. They would not flag non-reserve owning subsidiaries or parent companies. If reserve-owning subsidiaries are listed separately from their parent, and their reserves are reported separately from the parent, but their emissions do not merit inclusion in the Carbon Underground 200\u2122, the equities of those subsidiaries may not be flagged by screening. Given the continual mergers and acquisitions, closures, delisting, and IPO activities in the coal, oil, and gas industries, the Carbon Underground 200\u2122 list represents a best-efforts attempt at researching listed companies and basing the analysis on the latest available information.'
                    )
                  )
                ),
                _react2.default.createElement(_components.AboutBanner, null)
              )
            )
          )
        )
      );
    }
  }]);
  return CarbonUnderground200;
}(_react.Component)) || _class);
exports.default = CarbonUnderground200;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CarbonUnderground200/CarbonUnderground200.js
// module id = 1396
// module chunks = 0